import { render, staticRenderFns } from "./Routes.vue?vue&type=template&id=6a8de34f&scoped=true"
import script from "./Routes.vue?vue&type=script&lang=js"
export * from "./Routes.vue?vue&type=script&lang=js"
import style0 from "./Routes.vue?vue&type=style&index=0&id=6a8de34f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8de34f",
  null
  
)

export default component.exports